import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { isNullOrUndefined } from '@pineapplelab/util';
import { LandingPage } from 'src/app/models/firebase/landing-page';
import { SocialMedia } from 'src/app/models/firebase/socialMedia';
import { DbService } from '../db/db.service';
import { Project } from 'src/app/models/firebase/project';
import { BehaviorSubject, Observable } from 'rxjs';
import { GetLanguageService } from '../get-language/get-language.service';
import { LandingPageBanner } from 'src/app/models/firebase/landingPageBanner';

@Injectable({
    providedIn: 'root',
})
export class LandingPageService {
    private landingPageSubject = new BehaviorSubject<LandingPage>(null);
    landingPage$: Observable<LandingPage | null> = this.landingPageSubject.asObservable();

    landingPage: LandingPage;
    landingPageBanner: LandingPageBanner;

    constructor(private firestore: AngularFirestore, private db: DbService, private getLanguageService: GetLanguageService) {}

    async getLandingPageData(projectId: string): Promise<LandingPage> {
        const language = this.getLanguageService.currentLanguage;
        return await this.getLandingPageDataByLanguage(projectId, language);
    }

    async getLandingPageDataByLanguage(projectId: string, language: string): Promise<LandingPage> {
        const resDataPromise = await this.firestore.firestore
            .collection('projects')
            .doc(projectId)
            .collection('landingPage')
            .where('is_deleted', '==', false)
            .where('language', '==', language)
            .get();

        if (resDataPromise.docs.length === 0) {
            return null;
        }
        this.landingPage =  resDataPromise.docs.map((data) => new LandingPage(data.data())).pop();
        return this.landingPage;
    }

    async getSocialMedia(projectId: string, landingPageId: string) {
        let resData = this.firestore.collection('projects').doc(projectId).collection('landingPage').doc(landingPageId).collection(SocialMedia.PATH).get();
        return resData;
    }

    async saveLandingPage(model: LandingPage, projectId: string) {
        if (isNullOrUndefined(model.id)) {
            model.id = this.db.createId();
        }
        const json = model.toJson();

        await this.db.firestore.collection(Project.PATH).doc(projectId).collection(LandingPage.PATH).doc(model.id).set(json, { merge: true });

        return json;
    }
    async getLandingPageBannerDataByLanguage(projectId: string, language: string): Promise<LandingPageBanner> {
        const resDataPromise = await this.firestore.firestore
            .collection('projects')
            .doc(projectId)
            .collection(LandingPageBanner.PATH)
            .where('is_deleted', '==', false)
            .where('language', '==', language)
            .get();

        if (resDataPromise.docs.length === 0) {
            return null;
        }
        this.landingPageBanner =  resDataPromise.docs.map((data) => new LandingPageBanner(data.data())).pop();
        return this.landingPageBanner;
    }

    async getLandingPageBanner(projectId: string): Promise<LandingPageBanner>{
        const language = this.getLanguageService.currentLanguage;
        return await this.getLandingPageBannerDataByLanguage(projectId, language);
    }
}
